export default {
    CANNOT_ACCESS_LOOTBAG: 'Du kannst im Moment nicht auf diesen Beutel zugreifen.',
    REQUIRES_ACHIEVEMENT:
        'Dieser Gegenstand erfordert eine geheime Errungenschaft, um ihn auszurüsten zu können.',
    REQUIRES_QUEST: 'Du musst {{quest}} abschließen, um diesen Gegenstand auszurüsten zu können.',
    SKILL_LEVEL_REQUIREMENT_EQUIP:
        'Dein {{skill}} muss mindestens Level {{level}} sein, um diesen Gegenstand auszurüsten zu können.',
    TOTAL_LEVEL_REQUIREMENT:
        'Dein Gesamtlevel muss mindestens {{level}} sein, um diesen Gegenstand ausrüsten zu können.'
} as const;
